<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start"><ion-menu-button></ion-menu-button></ion-buttons>
    <ion-title>Feladataim</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="bd-lap">
    <p class="bd-lead" *ngIf="tanuloNezet">
      A tanáraid által kiadott beadandó feladatok. A választ szövegként írhatod, és fájlt is csatolhatsz; a
      határidőig módosíthatod. A tanár visszajelzése itt jelenik meg.
    </p>
    <p class="bd-lead" *ngIf="!tanuloNezet">
      A gyermek beadandó feladatai, a beadásai és a tanár visszajelzése. Beadni a gyermek a saját belépésével tud.
    </p>

    <div class="bd-allapot" *ngIf="toltodik"><ion-spinner name="dots"></ion-spinner><span>Betöltés…</span></div>
    <div class="bd-allapot hiba" *ngIf="!toltodik && hiba"><ion-icon name="alert-circle-outline"></ion-icon><span>{{ hiba }}</span></div>
    <div class="bd-ures" *ngIf="!toltodik && !hiba && !gyerekek.length">Nincs a fiókhoz rendelt tanuló.</div>

    <ion-item *ngIf="!tanuloNezet && gyerekek.length > 1">
      <ion-select label="Gyermek" label-placement="stacked" interface="popover" [ngModel]="kivalasztott"
                  (ionChange)="gyerekValtas($event.detail.value)">
        <ion-select-option *ngFor="let g of gyerekek" [value]="g.oktazon">{{ g.nev }}{{ g.osztaly ? ' (' + g.osztaly + ')' : '' }}</ion-select-option>
      </ion-select>
    </ion-item>

    <ion-segment *ngIf="gyerekek.length" [(ngModel)]="szuro" class="bd-szuro">
      <ion-segment-button value="nyitott"><ion-label>Aktuális</ion-label></ion-segment-button>
      <ion-segment-button value="mind"><ion-label>Összes</ion-label></ion-segment-button>
    </ion-segment>

    <div class="bd-allapot" *ngIf="listaToltodik"><ion-spinner name="dots"></ion-spinner><span>Betöltés…</span></div>
    <div class="bd-ures" *ngIf="!listaToltodik && gyerekek.length && !hiba && !lathato.length">
      {{ szuro === 'nyitott' ? 'Nincs aktuális beadandó feladat.' : 'Még nincs beadandó feladat.' }}
    </div>

    <ion-card *ngFor="let f of lathato">
      <ion-card-header>
        <ion-card-subtitle>{{ f.tantargy }}<span *ngIf="f.tanar"> · {{ f.tanar }}</span></ion-card-subtitle>
        <ion-card-title>{{ f.cim }}</ion-card-title>
      </ion-card-header>
      <ion-card-content>
        <div class="bd-tanulo-fej">
          <ion-badge [color]="allapot(f).szin">{{ allapot(f).szoveg }}</ion-badge>
          <span class="bd-ido">Határidő: <b>{{ idoKiir(f.hatarido) }}</b></span>
          <span class="bd-ido" *ngIf="!f.keso_beadas">· határidő után nem adható be</span>
        </div>
        <p class="bd-leiras" *ngIf="f.leiras">{{ f.leiras }}</p>
        <p *ngIf="f.csatolmany">
          <ion-button size="small" fill="outline" (click)="csatolmanyMegnyit(f)">
            <ion-icon slot="start" name="attach-outline"></ion-icon>{{ f.csatolmany.nev }}
          </ion-button>
        </p>

        <!-- A BEADÁS -->
        <div *ngIf="f.beadas" class="bd-beadas">
          <h3 class="bd-osszeg">
            {{ tanuloNezet ? 'A beadásod' : 'A beadás' }} · {{ idoKiir(f.beadas.beadva) }}<span *ngIf="f.beadas.keso"> (késve)</span>
          </h3>
          <p class="bd-valasz" *ngIf="f.beadas.szoveg && !f.beadhato">{{ f.beadas.szoveg }}</p>
          <div class="bd-fajlok" *ngIf="f.beadas.fajlok?.length">
            <ion-chip *ngFor="let x of f.beadas.fajlok" [outline]="true">
              <ion-icon name="document-outline"></ion-icon>
              <ion-label (click)="fajlMegnyit(x)">{{ x.fajlnev }} ({{ meretKiir(x.meret) }})</ion-label>
              <ion-icon name="close-circle" *ngIf="sajat && f.beadhato" (click)="fajlTorles(f, x)" aria-label="Fájl törlése"></ion-icon>
            </ion-chip>
          </div>
        </div>

        <!-- A TANÁR VISSZAJELZÉSE -->
        <div class="bd-visszajelzes" *ngIf="f.beadas?.visszajelzes || f.beadas?.ertekeles">
          <h3 class="bd-osszeg"><ion-icon name="chatbubble-ellipses-outline" aria-hidden="true"></ion-icon> A tanár visszajelzése</h3>
          <p *ngIf="f.beadas.ertekeles"><b>Értékelés:</b> {{ f.beadas.ertekeles }}</p>
          <p class="bd-valasz" *ngIf="f.beadas.visszajelzes">{{ f.beadas.visszajelzes }}</p>
          <ion-note color="medium" *ngIf="f.beadas.visszajelezve">{{ idoKiir(f.beadas.visszajelezve) }}</ion-note>
        </div>

        <!-- BEADÁS / MÓDOSÍTÁS – csak a tanuló saját belépésével -->
        <div *ngIf="sajat && f.beadhato" class="bd-uj-beadas">
          <ion-item>
            <ion-textarea [label]="f.beadas ? 'Válasz (módosítható)' : 'Válasz'" label-placement="stacked"
                          [(ngModel)]="f.ujSzoveg" [autoGrow]="true" rows="3"></ion-textarea>
          </ion-item>
          <ion-item lines="none">
            <ion-label position="stacked">Fájl(ok) csatolása – legfeljebb 5 egyszerre, fájlonként 20 MB</ion-label>
            <input #beadFajl type="file" multiple [accept]="fajlTipusok" (change)="fajlValasztas(f, $event)" class="bd-fajl" />
          </ion-item>
          <ion-button (click)="beadas(f, beadFajl)" [disabled]="kuld[f.id]">
            <ion-icon slot="start" name="cloud-upload-outline"></ion-icon>
            {{ kuld[f.id] ? 'Küldés…' : (f.beadas ? 'Beadás módosítása' : (f.lejart ? 'Beadás késve' : 'Beadás')) }}
          </ion-button>
        </div>
        <ion-note color="medium" *ngIf="!sajat && !f.beadas" class="bd-sugo">Még nincs beadva.</ion-note>
      </ion-card-content>
    </ion-card>
  </div>
</ion-content>
